import { useContext } from '@berlin-front/common/composables/context';
import { MemberRequestContext } from './MemberRequestContext';

/**
 * まとめ払いにおける会員登録フローの出入りを検出してフォームデータ他を設定する。
 */
export const AtoneAuthNPMemberRegisterModify = () => {
  const req = useContext(MemberRequestContext);

  // NP会員ルートではメールアドレスの変更できない。
  req.isEmailEditable.value = false;

  // NP会員からの変更ルートは8
  req.memberRegistrationRoute.value = 8;
};
